// extracted by mini-css-extract-plugin
export default {"navMobile":"nav_navMobile__jLof8","nav":"nav_nav__pv2vz","navItem":"nav_navItem__wOezu"};